// extracted by mini-css-extract-plugin
export var container = "_79-0";
export var icon = "_79-1";
export var text = "_79-2";